import { useQuery } from "react-query";
import { useConfigurationApi } from "./useConfigurationApi";

const queryKeys = {
    countries: ["countries"],
};

export const useConfigurationData = () => {
    const { findAllCountries } = useConfigurationApi();

    const countriesQueryResults = useQuery({
        queryKey: queryKeys.countries,
        queryFn: () => findAllCountries(),
        staleTime: Infinity,
    });

    return {
        countriesQueryResults,
    };
};
